/**
 * Atlas v2's fourteen states, in order (mirrors `atlas/pipeline.py` PIPELINE).
 * `stage` is the key Atlas uses in `/api/runs/{id}/stages` and downloads. The
 * run view takes its list from Atlas (`progress.stages`); this is the fallback
 * before the first sync, and the list downloads walk.
 */
export const PIPELINE = [
  { n: '1', name: 'Lead', stage: 'analysis_lead', kind: 'agent' },
  { n: '2', name: 'LeadGate', stage: 'lead_gate', kind: 'script' },
  { n: '3', name: 'Analysis', stage: 'analysis', kind: 'agent' },
  { n: '4', name: 'Flow', stage: 'analysis_flow', kind: 'agent' },
  { n: '5', name: 'SchemaGate', stage: 'schema_gate', kind: 'script' },
  { n: '6', name: 'BrainPlan', stage: 'brain_plan', kind: 'agent' },
  { n: '7', name: 'Brain', stage: 'brain', kind: 'agent' },
  { n: '8', name: 'BrainGate', stage: 'brain_gate', kind: 'script' },
  { n: '9', name: 'Strategist', stage: 'strategist', kind: 'agent' },
  { n: '10', name: 'StrategistGate', stage: 'strategist_gate', kind: 'script' },
  { n: '11', name: 'StrategistSummary', stage: 'strategist_summary', kind: 'agent' },
  { n: '12', name: 'MergeLint', stage: 'merge_lint', kind: 'script' },
  { n: '13', name: 'Blueprint', stage: 'blueprint', kind: 'script' },
  { n: '14', name: 'Finalize', stage: 'finalize', kind: 'script' },
] as const;

/** One state of a run's pipeline, as Atlas lists it. */
export interface PipelineStage {
  n: string;
  name: string;
  stage: string | null;
  kind: string;
}

/** Human labels for the stage timeline (v1 names kept for runs from before v2). */
export const STAGE_LABELS: Record<string, string> = {
  Lead: 'Lead',
  LeadGate: 'Lead gate',
  Analysis: 'Analysis',
  Flow: 'Flow',
  SchemaGate: 'Schema gate',
  BrainPlan: 'Brain plan',
  Brain: 'Brain',
  BrainGate: 'Brain gate',
  Strategist: 'Strategist',
  StrategistGate: 'Strategist gate',
  StrategistSummary: 'Strategist summary',
  MergeLint: 'MergeLint',
  Blueprint: 'Blueprint',
  Finalize: 'Finalize',
  Discovery: 'Discovery',
  WaitForAnswers: 'Waiting for answers',
  ValidateAnswers: 'Validate answers',
  PillarDiscovery: 'Pillar discovery',
  PillarGate: 'Pillar gate',
  SkillFetch: 'Skill fetch',
};

/** Atlas v2 `runs.status` values. */
export const ATLAS_RUN_STATUSES = [
  'created',
  'queued',
  'running',
  'quarantined',
  'complete',
  'partial',
  'failed',
  // A panel run that stopped after a pause, and one cancelled from the panel.
  'paused',
  'cancelled',
] as const;
export type AtlasRunStatus = (typeof ATLAS_RUN_STATUSES)[number];
